import { render, staticRenderFns } from "./NsProductDetailBase.vue?vue&type=template&id=a217b9a8&scoped=true&"
import script from "./NsProductDetailBase.vue?vue&type=script&lang=js&"
export * from "./NsProductDetailBase.vue?vue&type=script&lang=js&"
import style0 from "./NsProductDetailBase.vue?vue&type=style&index=0&id=a217b9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a217b9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a217b9a8')) {
      api.createRecord('a217b9a8', component.options)
    } else {
      api.reload('a217b9a8', component.options)
    }
    module.hot.accept("./NsProductDetailBase.vue?vue&type=template&id=a217b9a8&scoped=true&", function () {
      api.rerender('a217b9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsProductDetailBase.vue"
export default component.exports